import React from "react";
import RouterIndex from "./route-controller-mod/route-serv/route-configuration/routeConfiguration";
import { CookiesProvider } from "./context-controller-mod/context-serv/global-provider/cookies-context/cookiesContext";

const App: React.FC = () => {
  return (
    <CookiesProvider>
      <RouterIndex />
    </CookiesProvider>
  );
};

export default App;
